var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',{attrs:{"cols":"12","lg":"8"}},[_c('Overview')],1),_c('b-col',{attrs:{"cols":"12","lg":"4"}},[_c('DisbursementCard'),_c('CollectionCard'),_c('RedemptionCard')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }